import { Api } from 'utils';

class LawyerService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/lawyers/get', params),
    create: async (params?: any) => Api.createResponse('admin/lawyers/create', params),
    update: async (params?: any) => Api.createResponse('admin/lawyers/update', params),
    delete: async (params?: any) => Api.createResponse('admin/lawyers/delete', params),
    download: async (params?: any) => Api.createResponse('admin/lawyers/download', params),
    // Exports segmentados del botón "Descargar Excel" (ver Constants.LEAD_SEGMENTS
    // en el backend). Cada uno solo agrega el parámetro `segment` al mismo
    // endpoint de download -- no son rutas nuevas.
    downloadMQL: async (params?: any) =>
      Api.createResponse('admin/lawyers/download', { ...params, segment: 'MQL' }),
    downloadSAL: async (params?: any) =>
      Api.createResponse('admin/lawyers/download', { ...params, segment: 'SAL' }),
    downloadSQL: async (params?: any) =>
      Api.createResponse('admin/lawyers/download', { ...params, segment: 'SQL' }),
    changeStatus: async (params?: any) => Api.createResponse('admin/lawyers/change-status', params),
    updateDocs: async (params?: any) => Api.createResponse('admin/lawyers/update-docs', params),
  };
}

export default LawyerService;
